import { Pipe, PipeTransform } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Pipe({
  name: 'findControl',
})
export class FindControllPipe implements PipeTransform {
  transform(formArray: FormArray, id: number): FormGroup {
    const index = formArray.controls.findIndex(formControl => {
      if (formControl.value.id === id) {
        return formControl;
      }

      return false;
    });

    const group = formArray.at(index);

    return group as FormGroup;
  }
}
